import { BillingAriaStatusModel } from "./billing-aria-status.model";
import { BillingAriaEtabModel } from "./billing-aria-etab.model";
import { BillingAriaInvoiceModel } from "./billing-aria-invoice.model";

export const IBillingAria = Object.freeze({
  billingSessionId: "billing_session_id",
  invoiceId: "invoice_id",
  invoice: "invoice",
  etab: "etab",
  ariaStatus: "aria_status",
  stripeStatus: "stripe_status",
});

export const IBillingAriaColumns = Object.freeze({
  select: "select",
  date: "date",
  invoiceId: "invoiceId",
  billingSessionId: "billingSessionId",
  boId: "boId",
  name: "name",
  amount: "amount",
  balance: "balance",
  authorized: "authorized",
  remaining: "remaining",
  ariaStatus: "ariaStatus",
  stripeStatus: "stripeStatus",
});

export class BillingAriaModel {
  constructor(data = {}) {
    this[IBillingAria.billingSessionId] = data[IBillingAria.billingSessionId];
    this[IBillingAria.invoiceId] = data[IBillingAria.invoiceId];
    this[IBillingAria.invoice] = data[IBillingAria.invoice];
    this[IBillingAria.etab] = data[IBillingAria.etab];
    this[IBillingAria.ariaStatus] = data[IBillingAria.ariaStatus];
    this[IBillingAria.stripeStatus] = data[IBillingAria.stripeStatus];
  }

  getId() {
    return this[IBillingAria.billingSessionId];
  }

  getInvoice() {
    return this[IBillingAria.invoice] ? new BillingAriaInvoiceModel(this[IBillingAria.invoice]) : null;
  }

  getInvoiceId() {
    return this[IBillingAria.invoiceId];
  }

  getEtab() {
    return new BillingAriaEtabModel(this[IBillingAria.etab]);
  }

  getAriaStatus() {
    return new BillingAriaStatusModel(this[IBillingAria.ariaStatus]);
  }

  getStripeStatus() {
    return new BillingAriaStatusModel(this[IBillingAria.stripeStatus]);
  }
}
